<template>
  <div class="modal_wrapper active">
    <div class="modal_window white_box competitor_keywords_modal">
      <div class="heading_wrapper">
        <h3 class="heading">
          Matching keywords
        </h3>
        <button
          class="close_modal close_btn"
          @click="closeModal()"
        >
          <svg
            fill="none"
            height="32"
            viewBox="0 0 32 32"
            width="32"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M25 7L7 25"
              stroke="#040707"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            />
            <path
              d="M25 25L7 7"
              stroke="#040707"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            />
          </svg>
        </button>
      </div>

      <div class="desc">
        Matching keywords for: <a
          :href="competitor.website"
          target="_blank"
        >{{ competitor.website }}</a>
      </div>

      <table class="keywords_table head">
        <thead>
          <tr>
            <th>Keyword</th>
            <th width="15%">
              Position
            </th>
            <th>URL</th>
          </tr>
        </thead>
      </table>
      <div class="table_body_wrap">
        <table class="keywords_table">
          <tbody>
            <tr
              v-for="(serp, index) in sortedSerps"
              :key="index"
            >
              <td>{{ serp.keyword }}</td>
              <td width="15%">
                {{ serp.position }}
              </td>
              <td>
                <a
                  :href="serp.page"
                  :title="serp.page"
                  class="table_link tooltipster"
                  target="_blank"
                >
                  {{ urlPathname(serp.page) }}
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    competitor: {
      type: Object,
      default() {
        return {
          website: '',
          serps: [],
        }
      }
    }
  },
  computed: {
    sortedSerps() {
      let sorted = this.competitor.serps;
      return sorted.sort((a, b) => {
        return a.position - b.position;
      });
    }
  },
  methods: {
    urlPathname(url) {
      if (!url) {
        return '';
      }
      return (new URL(url)).pathname;
    },
    closeModal() {
      this.$parent.showCompetitorKeywordsModal = false;
    }
  }
}
</script>

<style scoped>
.modal_wrapper {
  z-index: 100;
  position: fixed;
  display: flex;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
  padding: 5vh 0;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.2);
}

.modal_wrapper::-webkit-scrollbar {
  width: 0;
}

.modal_window {
  position: relative;
  margin: auto;
  max-width: 800px;
  width: 90vw;
  z-index: 100;
  -webkit-box-shadow: 0px 10px 30px rgba(4, 7, 7, 0.2);
  box-shadow: 0px 10px 30px rgba(4, 7, 7, 0.2);
  border-radius: .75rem;
}

.heading_wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.close_btn {
  height: auto;
}

.heading {
  font-weight: 700;
  line-height: 1.42;
  letter-spacing: -0.042em;
  color: #040707;
  font-size: 1.5rem;
}

h4.heading {
  font-size: 1.2rem;
}

.desc {
  margin-bottom: 15px;
}

.table_body_wrap {
  width: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  max-height: 45vh;
}

.keywords_table {
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  table-layout: fixed;
}

.keywords_table thead tr th {
  padding: 0rem .75rem .75rem;
}

.keywords_table thead tr th:nth-of-type(2),
.keywords_table tbody tr td:nth-of-type(2) {
  text-align: center;
}

.keywords_table tr td:nth-of-type(3) {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: hidden;
}

.keywords_table tbody tr td {
  padding: .75rem;
}

.keywords_table thead th span {
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
  letter-spacing: -0.25px;
  margin-right: 0.25rem;
}

.keywords_table tbody tr:nth-of-type(2n+1) {
  background: var(--table-secondary-color);
}
</style>
